import { useToggle } from "@react-aria/toggle";
import _babelRuntimeHelpersEsmExtends from "@babel/runtime/helpers/esm/extends";
/**
 * Provides the behavior and accessibility implementation for a switch component.
 * A switch is similar to a checkbox, but represents on/off values as opposed to selection.
 * @param props - Props for the switch.
 * @param state - State for the switch, as returned by `useToggleState`.
 * @param ref - Ref to the HTML input element.
 */

export function useSwitch(props, state, ref) {
  var _useToggle = useToggle(props, state, ref),
      inputProps = _useToggle.inputProps;

  var isSelected = state.isSelected;
  return {
    inputProps: _babelRuntimeHelpersEsmExtends({}, inputProps, {
      role: 'switch',
      checked: isSelected,
      'aria-checked': isSelected
    })
  };
}